<template>
  <div>
    <div style="display: flex" v-show="detailDialog">
      <div class="flex">
        <div>
          <el-select class="btn" clearable v-model="symbolId" filterable placeholder="全部合约">
            <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol.toUpperCase()" :value="item.id">
            </el-option>
          </el-select>
          <el-input placeholder="订单id" clearable class="btn orderId" v-model="SearchOrderId"></el-input>
          <el-input placeholder="合约账户id" clearable class="btn accountId" v-model="accountId"></el-input>
          <el-input placeholder="用户id" clearable class="btn accountId" v-model="userId"></el-input>

          <el-select class="btn" clearable v-model="positionType" filterable placeholder="全部开仓类型">
            <el-option v-for="item in [
              { label: '全仓', value: 1 },
              { label: '逐仓', value: 2 },
            ]" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select class="btn" clearable v-model="sideType" filterable placeholder="全部方向">
            <el-option v-for="item in [
              { label: '买入开多', value: 11 },
              { label: '买入平空', value: 12 },
              { label: '卖出平多', value: 21 },
              { label: '卖出开空', value: 22 },
            ]" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>

          <el-select class="btn" clearable v-model="stateType" filterable placeholder="请选择订单状态">
            <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-select class="btn" clearable v-model="specialAccountType" filterable placeholder="请选择用户类型">
            <el-option v-for="item in userTypeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-date-picker v-model="value1" type="datetimerange" :picker-options="pickerOptions" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" @change="handleCycleTime" align="right">
          </el-date-picker>

          <el-button type="primary" @click="searchId" style="margin-left: 10px">搜索</el-button>
        </div>
        <!-- <div>
          <el-input placeholder="账户id" clearable class='btn' v-model="accountId"></el-input>
          <el-select v-model="symbolId" class='btn' clearable  filterable placeholder="请选择交易对">
          <el-option
            v-for="item in symbolList"
            :key="item.id"
            :label="item.symbol"
            :value="item.id">
          </el-option>
        </el-select>
          <el-button type="danger" @click="cancelAllOrder">一键撤销</el-button>
        </div> -->
      </div>
    </div>
    <div style="display: flex" v-show="!detailDialog">
      <i class="el-icon-back" @click="goback"></i>
      <!-- <el-input placeholder="订单id" class='btn'></el-input>
      <el-button type="primary">明细搜索</el-button> -->
    </div>

    <el-divider></el-divider>
    <el-table :data="orderList" size="small" v-show="detailDialog" border height="calc(100vh - 360px)">
      <el-table-column label="合约名" prop="symbol" fixed width="140px">
        <template slot-scope="scope">
          {{ scope.row.symbol.toUpperCase() }}
        </template>
      </el-table-column>
      <el-table-column label="订单id" prop="orderIdStr" fixed width="150px"></el-table-column>
      <el-table-column label="用户id" prop="userId" fixed width="150px"></el-table-column>
      <el-table-column label="合约账户id" prop="accountId" fixed width="150px"></el-table-column>
      <el-table-column label="订单类型" prop="orderType">
        <template slot-scope="scope">{{
          scope.row.orderType === 1 ? '限价' : '市价'
        }}</template>
      </el-table-column>
      <el-table-column label="订单方向">
        <template slot-scope="scope">
          <span class="take" v-if="scope.row.orderSide === 1 && scope.row.positionSide === 1">买入开多</span>
          <span class="take" v-if="scope.row.orderSide === 1 && scope.row.positionSide === 2">买入平空</span>
          <span class="sell" v-if="scope.row.orderSide === 2 && scope.row.positionSide === 1">卖出平多</span>
          <span class="sell" v-if="scope.row.orderSide === 2 && scope.row.positionSide === 2">卖出开空</span>
        </template>
      </el-table-column>
      <el-table-column label="委托数量" prop="origQty" width="150px" sortable></el-table-column>
      <el-table-column label="委托价格" prop="price" width="150px" sortable></el-table-column>
      <el-table-column label="成交数量" prop="executedQty" width="150px" sortable></el-table-column>

      <el-table-column label="成交均价" prop="avgPrice" align="center" width="150px" sortable></el-table-column>
      <!-- <el-table-column label="成交金额" prop="dealAmount" width="120px" align="center"></el-table-column>
     <el-table-column label="成交单位" prop="dealCoin" align="center"></el-table-column>
     <el-table-column label="交易对" prop="symbol" width="120px" align="center"></el-table-column>
     <el-table-column label="已成交数量" prop="executedQty" align="center" width="140"></el-table-column> -->
      <el-table-column label="手续费" align="center" prop="fee" width="150px" sortable>
        <template slot-scope="scope">{{
          scope.row.fee ? scope.row.fee : 0
        }}</template>
      </el-table-column>
      <!-- <el-table-column label="成交均价" prop="avgPrice" align="center"></el-table-column>
     <el-table-column label="下单方向" prop="orderSide" align="center">
      <template slot-scope="scope">{{
          scope.row.orderSide===1?'买入':'卖出'
        }}</template>
     </el-table-column> -->

      <el-table-column label="订单状态" width="150px">
        <template slot-scope="scope">
          <span v-if="scope.row.state === 1">新建订单</span>
          <span v-else-if="scope.row.state === 2">部分成交</span>
          <span v-else-if="scope.row.state === 3">全部成交</span>
          <span v-else-if="scope.row.state === 4">用户撤销</span>
          <span v-else-if="scope.row.state === 5">下单失败</span>
          <span v-else>已过期</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="150px" prop="createdTime" sortable>
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="150px" prop="updatedTime" sortable>
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="110px" align="center">
        <template slot-scope="scope">
          <!-- <el-button
          :disabled="scope.row.state==1||scope.row.state==2 ?false:true"
        
            size="mini"
            type="warning"
            @click="handleCancle(scope.row)"
          >撤销订单</el-button> -->
          <el-button size="mini" type="text" @click="getDetail(scope.row)">成交明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table :data="detailList" size="small" v-show="!detailDialog">
      <el-table-column label="订单编号" prop="orderIdStr" fixed></el-table-column>
      <el-table-column label="合约账户id" prop="accountId" fixed></el-table-column>
      <el-table-column label="对手合约账号id" prop="oppositeAccountId" fixed width="150px"></el-table-column>
      <el-table-column label="对手订单id" prop="oppositeOrderIdStr" fixed width="150px"></el-table-column>
      <el-table-column label="订单方向">
        <template slot-scope="scope">
          <span class="take" v-if="scope.row.orderSide === 1 && scope.row.positionSide === 1">买入开多</span>
          <span class="take" v-if="scope.row.orderSide === 1 && scope.row.positionSide === 2">买入平空</span>
          <span class="sell" v-if="scope.row.orderSide === 2 && scope.row.positionSide === 1">卖出平多</span>
          <span class="sell" v-if="scope.row.orderSide === 2 && scope.row.positionSide === 2">卖出开空</span>
        </template>
      </el-table-column>
      <el-table-column label="已成交数量" prop="quantity" align="center" sortable></el-table-column>
      <el-table-column label="成交价格" prop="price" align="center" sortable></el-table-column>
      <el-table-column label="手续费" align="center" sortable>
        <template slot-scope="scope">{{ scope.row.fee }}</template>
      </el-table-column>
      <el-table-column label="挂单类型" align="center">
        <template slot-scope="scope">{{
          scope.row.liquidityFlag == 2 ? 'Maker' : 'Taker'
        }}</template>
      </el-table-column>

      <el-table-column label="成交时间" width="140px" sortable>
        <template slot-scope="scope">{{
          scope.row.timestamp | moment
        }}</template>
      </el-table-column>
      <!-- <el-table-column  label="更新时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>
    
     <el-table-column label="dealAmount" prop="dealAmount" width="120px" align="center"></el-table-column>
     <el-table-column label="成交单位" prop="dealCoin" align="center"></el-table-column>
     <el-table-column label="交易对" prop="symbol" width="120px" align="center"></el-table-column>
    
  
     <el-table-column label="成交均价" prop="avgPrice" align="center"></el-table-column>
     <el-table-column label="下单方向" prop="orderSide" align="center">
      <template slot-scope="scope">{{
          scope.row.orderSide===1?'买入':'卖出'
        }}</template>
     </el-table-column>
     <el-table-column label="订单类型" prop="orderType">
      <template slot-scope="scope">{{
          scope.row.orderType===1?'限价':'市价'
        }}</template>
     </el-table-column>
      <el-table-column label="委托数量" prop="origQty"></el-table-column>
      <el-table-column label="委托价格" prop="price"></el-table-column>
      <el-table-column label="订单状态" >
        <template slot-scope="scope">
          <span v-if="scope.row.state===1">新建订单</span>
          <span v-else-if="scope.row.state===2">部分成交</span>
          <span v-else-if="scope.row.state===3">全部成交</span>
          <span v-else-if="scope.row.state===4">用户撤销</span>
          <span v-else-if="scope.row.state===5">下单失败</span>
          <span v-else="scope.row.state===6">已过期</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column label="操作" fixed="right" width='210px' >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="handleCancle(scope.row)"
          >撤销订单</el-button>
          <el-button  
            size="mini"
            type="primary" 
            @click="getDetail(scope.row)" 
          >查看明细</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <div class="page" v-show="detailDialog">
      <el-button @click="goPrev" style="margin-right: 20px" type="primary" icon="el-icon-arrow-left" circle
        :disabled="hasPrev == false"></el-button>
      <el-button @click="goNext" type="primary" icon="el-icon-arrow-right" circle
        :disabled="hasNext == false"></el-button>
    </div>

    <!-- <pagination
    v-show="detailDialog"
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination> -->
    <pagination v-show="!detailDialog" :size="pagination.size" :total="detailTotal" :page="pagination.page"
      @pageChanged="pageChanged"></pagination>
    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'

export default {
  name: 'OrderList',
  data() {
    return {
      // hasPrev:true,
      // hasNext:null,
      positionType: '',
      sideType: '',
      specialAccountType: '',
      userId: '',
      defalutSymbolId: 1,
      defalutAccountId: null,
      detailDialog: true,
      SearchOrderId: '',
      list: [],
      value1: [],
      accountId: null,
      symbolId: '',
      limit: 15,
      updateForm: {},
      stateType: '',
      specialAccountType: '',
      isRobotOptions: [
        { label: '全部', value: '' },
        { label: '机器人订单', value: true },
        { label: '非机器人订单', value: false },
      ],
      userTypeOptions: [
        { label: '普通用户', value: 0 },
        { label: '内部做市商', value: 1 },
        { label: '外部做市商', value: 2 },
        { label: '项目做市商', value: 3 },
      ],
      stateOptions: [
        { label: '新建订单', value: 1 },
        { label: '部分成交', value: 2 },
        { label: '全部成交', value: 3 },
        { label: '用户撤销', value: 4 },
        { label: '下单失败', value: 5 },
        { label: '已过期', value: 6 },
      ],
      userTypes: {
        1: '无效用户',
        2: '普通用户',
        3: '初级股东',
        4: '中级股东',
        5: '高级股东',
      },
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  components: {
    Pagination,
    updateDialog,
  },
  watch: {
    symbolId: {
      handler(val, oldVal) {
        if (!val) {
          this.$message.warning('请选择合约')
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    this.setOrderList(null)
  },
  methods: {
    ...mapActions('closingCommission', ['getSymbolList']),
    ...mapActions('activeHistory', [
      'getOrderList',
      'getOrderDetails',
      'cancleOrder',
      'cancelAll',
      'getPairList',
    ]),
    ...mapMutations('activeHistory', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setOrderList',
    ]),
    changeTime(e) { },
    handleCycleTime(date) {
      this.value1 = date ? date : []
    },
    searchId() {
      console.log('value1', [...this.value1])
      if (this.symbolId) {
        this.getOrderList({
          symbolId: this.symbolId,
          userId: this.userId,
          limit: this.limit,
          state: this.stateType,
          orderId: this.SearchOrderId,
          accountId: this.accountId,
          orderSide: this.sideType ? this.sideType.toString().split('')[0] : '',
          positionSide: this.sideType
            ? this.sideType.toString().split('')[1]
            : '',
          specialAccountType: this.specialAccountType,
          startTime:
            this.value1 != null && this.value1.length
              ? this.value1[0].valueOf()
              : '',
          endTime:
            this.value1 != null && this.value1.length
              ? this.value1[1].valueOf()
              : '',
        })
      } else {
        this.$message.warning('合约不能为空')
      }
    },
    goPrev() {
      this.getOrderList({
        symbolId: this.symbolId,
        userId: this.userId,
        limit: this.limit,
        state: this.stateType,
        orderId: this.SearchOrderId,
        accountId: this.accountId,
        orderSide: this.sideType ? this.sideType.toString().split('')[0] : '',
        positionSide: this.sideType
          ? this.sideType.toString().split('')[1]
          : '',
        specialAccountType: this.specialAccountType,
        startTime:
          this.value1 != null && this.value1.length
            ? this.value1[0].valueOf()
            : '',
        endTime:
          this.value1 != null && this.value1.length
            ? this.value1[1].valueOf()
            : '',
        direction: 'PREV',
        id: this.orderList[0].orderId,
      })
    },
    goNext() {
      this.getOrderList({
        symbolId: this.symbolId,
        userId: this.userId,
        limit: this.limit,
        state: this.stateType,
        orderId: this.SearchOrderId,
        accountId: this.accountId,
        orderSide: this.sideType ? this.sideType.toString().split('')[0] : '',
        positionSide: this.sideType
          ? this.sideType.toString().split('')[1]
          : '',
        specialAccountType: this.specialAccountType,
        startTime:
          this.value1 != null && this.value1.length
            ? this.value1[0].valueOf()
            : '',
        endTime:
          this.value1 != null && this.value1.length
            ? this.value1[1].valueOf()
            : '',
        direction: 'NEXT',
        id: this.orderList[this.orderList.length - 1].orderId,
      })
    },
    pageChanged(pagination) {
      this.limit = pagination.size
      this.getOrderList({
        symbolId: this.symbolId,
        userId: this.userId,
        limit: this.limit,
        state: this.stateType,
        orderId: this.SearchOrderId,
        accountId: this.accountId,
        orderSide: this.sideType ? this.sideType.toString().split('')[0] : '',
        positionSide: this.sideType
          ? this.sideType.toString().split('')[1]
          : '',
        specialAccountType: this.specialAccountType,
        startTime:
          this.value1 != null && this.value1.length
            ? this.value1[0].valueOf()
            : '',
        endTime:
          this.value1 != null && this.value1.length
            ? this.value1[1].valueOf()
            : '',
      })
      this.$emit('refresh', pagination)
    },
    goback() {
      this.detailDialog = true
    },
    //撤销所有订单
    cancelAllOrder() {
      this.$confirm('此操作将撤销所选用户所有订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.cancelAll({
            accountId: Number(this.accountId),
            symbolId: this.symbolId,
          }).then((res) => {
            if (res.code == 0) {
              this.searchId()
              this.$message({
                type: 'success',
                message: '撤销成功!',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤销',
          })
        })
    },
    //撤销订单
    handleCancle(row) {
      this.cancleOrder(row.orderId).then((res) => {
        if (res.code == 0) {
          this.searchId()
        }
      })
    },
    //查看成交明细
    getDetail(row) {
      ; (this.detailDialog = false),
        this.getOrderDetails({ page: 1, orderId: row.orderIdStr, size: 25 }).then(
          (res) => {
            console.log(res, '-------------');
          }
        )
    },
  },
  computed: {
    ...mapState('closingCommission', ['symbolList']),
    ...mapGetters('activeHistory', ['userList']),
    ...mapState('activeHistory', [
      'pairList',
      'hasPrev',
      'hasNext',
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'orderList',
      'detailList',
      'detailTotal',
    ]),
  },

  mounted() {
    this.getSymbolList()
    if (this.symbolId) {
      this.getOrderList({
        symbolId: this.symbolId,
        userId: this.userId,
        limit: this.limit,
        state: this.stateType,
        orderId: this.SearchOrderId,
        accountId: this.accountId,
        orderSide: this.sideType ? this.sideType.toString().split('')[0] : '',
        positionSide: this.sideType
          ? this.sideType.toString().split('')[1]
          : '',
        specialAccountType: this.specialAccountType,
        startTime: '',
        endTime: '',
      })
    }
  },
}
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}

.page {
  // margin-top: 30px;
  width: 100px;
  margin: 30px auto;
  display: flex;
}

.take {
  color: #2ec6a0 !important;
}

.sell {
  color: #dc3545 !important;
}

.red {
  color: skyblue;
  font-weight: bold;
}

.el-icon-back:before {
  content: '\E6EA';
  font-size: 30px;
  cursor: pointer;
  line-height: 40px;
}

.el-icon-back {
  width: 40px;
  height: 40px;
}

.flex {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.btn {
  width: 160px;
  margin-right: 10px;
  margin-bottom: 5px;
}

.accountId {
  width: 180px;
}

.orderId {
  width: 200px;
}
</style>
